import { Directive, Output, EventEmitter, Input } from "@angular/core";
import { SortEvent } from "../interfaces/sort-event";
import { SortDirection } from "../types/sort-direction";

const rotate: { [key: string]: SortDirection } = { 'asc': 'desc', 'desc': '', '': 'asc' };

@Directive({
    selector: 'th[sortable]',
    host: {
        '[class.asc]': 'direction === "asc"',
        '[class.desc]': 'direction === "desc"',
        '[class.def]': 'direction === ""',
        '(click)': 'rotate()'
    }
})
export class NgbdSortableHeader {

    @Input() sortable!: string;
    @Input() direction: SortDirection = '';
    @Output() sort = new EventEmitter<SortEvent>();

    rotate() {
        this.direction = rotate[this.direction];
        this.sort.emit({ column: this.sortable, direction: this.direction });
    }
}